module.exports = __webpack_public_path__ + "static/tabletcategorias-8942de3987f70db547e9e14807a66d45.png";